<template>
  <div class="speakers-page">
    <!-- Editorial Hero -->
    <section class="ahrs-page-hero hero-photo-speakers">
      <div class="ahrs-page-hero-wrap">
        <div class="ahrs-page-eyebrow" data-aos="fade-up">
          <span class="dot"></span>Distinguished Speakers
        </div>
        <h1 class="ahrs-page-title" data-aos="fade-up" data-aos-delay="100">
          Voices shaping
          <span class="ahrs-page-italic">Africa&rsquo;s future of work.</span>
        </h1>
        <p class="ahrs-page-lede" data-aos="fade-up" data-aos-delay="200">
          Join distinguished HR leaders, policymakers, and innovation experts
          from across Africa and beyond at AHRS 2026, Arusha, Tanzania.
        </p>
        <div class="ahrs-page-meta" data-aos="fade-up" data-aos-delay="300">
          <div class="m">
            <svg viewBox="0 0 24 24" stroke-linecap="round">
              <rect x="3" y="4.5" width="18" height="17" rx="2" />
              <path d="M3 9h18M8 2.5v4M16 2.5v4" />
            </svg>
            19&ndash;22 August 2026
          </div>
          <div class="m">
            <svg viewBox="0 0 24 24" stroke-linecap="round">
              <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" />
              <circle cx="12" cy="10" r="2.6" />
            </svg>
            Mount Meru Hotel, Arusha
          </div>
        </div>
        <div class="ahrs-page-stats" data-aos="fade-up" data-aos-delay="400">
          <div class="ahrs-page-stat">
            <span class="n">18+</span>
            <span class="l">Speakers</span>
          </div>
          <div class="ahrs-page-stat">
            <span class="n">8</span>
            <span class="l">Countries</span>
          </div>
          <div class="ahrs-page-stat">
            <span class="n">4</span>
            <span class="l">Sessions</span>
          </div>
          <div class="ahrs-page-stat">
            <span class="n">3</span>
            <span class="l">Days</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Speaker Categories -->
    <section class="speakers-content">
      <div class="container-wide">

        <!-- Guest of Honor -->
        <div class="honor-block" data-aos="zoom-in">
          <div class="honor-card">
            <div class="honor-shine"></div>
            <div class="honor-corner honor-corner-tl"></div>
            <div class="honor-corner honor-corner-br"></div>
            <span class="honor-badge"><i class="fas fa-award"></i> Guest of Honor</span>
            <div class="honor-avatar">
              <div class="honor-avatar-inner"><i class="fas fa-user-tie"></i></div>
            </div>
            <h2 class="honor-name">To Be Announced</h2>
            <p class="honor-role">Guest of Honor</p>
            <div class="honor-divider">
              <span></span><i class="fas fa-leaf"></i><span></span>
            </div>
            <p class="honor-note">TANZANIA</p>
          </div>
        </div>

        <!-- Special Guests -->
        <div class="category-block" data-aos="fade-up">
          <div class="category-header">
            <div class="category-icon"><i class="fas fa-crown"></i></div>
            <h2 class="category-title">Special Guests</h2>
          </div>
          <div class="speakers-grid special-guests-grid">
            <div class="speaker-card featured-card" data-aos="zoom-in" data-aos-delay="100">
              <div class="card-glow"></div>
              <div class="speaker-tag">Special Guest</div>
              <div class="speaker-avatar">
                <img :src="photos.haroun" alt="Hon. Dr. Haroun Ali Suleiman" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Hon. Dr. Haroun Ali Suleiman</h3>
              <p class="speaker-role">Minister of State</p>
              <p class="speaker-org">President's Office<br> Constitution, Legal Affairs, Public Service &amp;<br></br> Good Governance</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/tz.svg" alt="Tanzania flag" /> Tanzania</p>
            </div>
            <div class="speaker-card featured-card" data-aos="fade-up" data-aos-delay="150">
              <div class="card-glow"></div>
              <div class="speaker-tag">Special Guest</div>
              <div class="speaker-avatar">
                <div class="avatar-initials avatar-tba"><i class="fas fa-user"></i></div>
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">To Be Announced</h3>
            </div>
            <div class="speaker-card featured-card" data-aos="fade-up" data-aos-delay="200">
              <div class="card-glow"></div>
              <div class="speaker-tag">Special Guest</div>
              <div class="speaker-avatar">
                <img :src="photos.deus" alt="Hon. Deus Clement Sangu" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Hon. Deus Clement Sangu</h3>
              <p class="speaker-role">Minister of State</p>
              <p class="speaker-org">Prime Minister's Office<br> Labour, Employment and Relations</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/tz.svg" alt="Tanzania flag" /> Tanzania</p>
            </div>
          </div>
        </div>

        <!-- Keynote Speakers -->
        <div class="category-block" data-aos="fade-up">
          <div class="category-header">
            <div class="category-icon"><i class="fas fa-bullhorn"></i></div>
            <h2 class="category-title">Keynote Speakers</h2>
          </div>
          <div class="speakers-grid">
            <div class="speaker-card featured-card" data-aos="zoom-in" data-aos-delay="100">
              <div class="card-glow"></div>
              <div class="speaker-tag">Keynote</div>
              <div class="speaker-avatar">
                <img :src="photos.bettina" alt="Bettina Schaller" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Bettina Schaller</h3>
              <p class="speaker-role">President</p>
              <p class="speaker-org">World Employment Confederation (WEC)</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/ch.svg" alt="Switzerland flag" /> Switzerland</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/bettinaschaller/?locale=en" target="_blank" rel="noopener" aria-label="Bettina Schaller on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card featured-card" data-aos="zoom-in" data-aos-delay="150">
              <div class="card-glow"></div>
              <div class="speaker-tag">Keynote</div>
              <div class="speaker-avatar">
                <img :src="photos.aida" alt="Aida J Troncoso" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Aida J Troncoso</h3>
              <p class="speaker-role">Vice President</p>
              <p class="speaker-org">World Federation of People Management Associations (WFPMA)</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/do.svg" alt="Dominican Republic flag" /> Dominican Republic</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/aida-josefina-troncoso-2b426640/" target="_blank" rel="noopener" aria-label="Aida J Troncoso on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="200">
              <div class="speaker-tag">Keynote</div>
              <div class="speaker-avatar">
                <div class="avatar-initials avatar-tba"><i class="fas fa-user"></i></div>
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">To Be Announced</h3>
            </div>
          </div>
        </div>

        <!-- Moderators -->
        <div class="category-block" data-aos="fade-up">
          <div class="category-header">
            <div class="category-icon"><i class="fas fa-microphone"></i></div>
            <h2 class="category-title">Moderators</h2>
          </div>
          <div class="speakers-grid">
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="100">
              <div class="speaker-tag">Moderator</div>
              <div class="speaker-avatar">
                <img :src="photos.quresha" alt="Quresha Abdullah" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Quresha Abdullah</h3>
              <p class="speaker-role">Executive Director</p>
              <p class="speaker-org">Institute of Human Resource Management Kenya</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/ke.svg" alt="Kenya flag" /> Kenya</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/quresha-ahmed-/" target="_blank" rel="noopener" aria-label="Quresha Abdullah on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="150">
              <div class="speaker-tag">Moderator</div>
              <div class="speaker-avatar">
                <img :src="photos.murtaza" alt="Murtaza Versi" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Murtaza Versi</h3>
              <p class="speaker-role">Founder &amp; CEO</p>
              <p class="speaker-org">Noesis Strategic Institute</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/tz.svg" alt="Tanzania flag" /> Tanzania</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/murtazagversi/" target="_blank" rel="noopener" aria-label="Murtaza Versi on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="200">
              <div class="speaker-tag">Moderator</div>
              <div class="speaker-avatar">
                <img :src="photos.suzan" alt="Suzan Ndomba-Doran" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Suzan Ndomba-Doran</h3>
              <p class="speaker-role">Chief Executive Officer</p>
              <p class="speaker-org">Association of Tanzania Employers</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/tz.svg" alt="Tanzania flag" /> Tanzania</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/suzanne-ndomba-doran-adv-0a6b1671/" target="_blank" rel="noopener" aria-label="Suzan Ndomba-Doran on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="250">
              <div class="speaker-tag">Moderator</div>
              <div class="speaker-avatar">
                <img :src="photos.tarek" alt="Dr. Tarek Dessouki" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Dr. Tarek Dessouki</h3>
              <p class="speaker-role">Regional Director &ndash; Africa</p>
              <p class="speaker-org">American International Certification Institute</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/eg.svg" alt="Egypt flag" /> Egypt</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/tarekdessouki/" target="_blank" rel="noopener" aria-label="Dr. Tarek Dessouki on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
          </div>
        </div>

        <!-- Panelists -->
        <div class="category-block" data-aos="fade-up">
          <div class="category-header">
            <div class="category-icon"><i class="fas fa-comments"></i></div>
            <h2 class="category-title">Panelists</h2>
          </div>
          <div class="speakers-grid">
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="100">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.ahmed" alt="Ahmed Ladan Gobir" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Ahmed Ladan Gobir</h3>
              <p class="speaker-role">President</p>
              <p class="speaker-org">Chartered Institute of Personnel Management of Nigeria</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/ng.svg" alt="Nigeria flag" /> Nigeria</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/ahmed-gobir-fcipm-fnli-fnim-29203864/" target="_blank" rel="noopener" aria-label="Ahmed Ladan Gobir on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="150">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.ibrahim" alt="Ibrahim Mbaye" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Ibrahim Mbaye</h3>
              <p class="speaker-role">President</p>
              <p class="speaker-org">National Association of Human Resource Management Directors of Senegal</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/sn.svg" alt="Senegal flag" /> Senegal</p>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="200">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.kelvin" alt="Kelvin Shamizhinga" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Kelvin Shamizhinga</h3>
              <p class="speaker-role">President</p>
              <p class="speaker-org">Zambia Institute of Human Resource Management</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/zm.svg" alt="Zambia flag" /> Zambia</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/kelvin-shamizhinga-mschrm-ba-fzihrm-cge-b14092181/" target="_blank" rel="noopener" aria-label="Kelvin Shamizhinga on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="250">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.sharon" alt="Sharon Maziya" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Sharon Maziya</h3>
              <p class="speaker-role">President</p>
              <p class="speaker-org">Institute of People Management Eswatini</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/sz.svg" alt="Eswatini flag" /> Eswatini</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/sharon-maziya-b563b134/" target="_blank" rel="noopener" aria-label="Sharon Maziya on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="100">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.kgothatso" alt="Prof. Kgothatso Shai" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Prof. Kgothatso Shai</h3>
              <p class="speaker-role">President</p>
              <p class="speaker-org">South African Association of Public Administration &amp; Management</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/za.svg" alt="South Africa flag" /> South Africa</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/kgothatso-shai-b29b9653/" target="_blank" rel="noopener" aria-label="Prof. Kgothatso Shai on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="150">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.francis" alt="Dr. Francis Eduku" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Dr. Francis Eduku</h3>
              <p class="speaker-role">Chief Executive Officer</p>
              <p class="speaker-org">Chartered Institute of Human Resource Management (CIHRM)</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/gh.svg" alt="Ghana flag" /> Ghana</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/feduku-b1b817b4/" target="_blank" rel="noopener" aria-label="Dr. Francis Eduku on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="200">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.zara" alt="Zara Marfo" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Zara Marfo</h3>
              <p class="speaker-role">Director (DEIS&amp;SR)</p>
              <p class="speaker-org">Adecco Group</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/gb.svg" alt="United Kingdom flag" /> United Kingdom</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/zara-m-585197144/" target="_blank" rel="noopener" aria-label="Zara Marfo on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="250">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.emmanuel" alt="Emmanuel Akonnay" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Emmanuel Akonaay</h3>
              <p class="speaker-role">Chief Human Resources Officer</p>
              <p class="speaker-org">National Microfinance Bank</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/tz.svg" alt="Tanzania flag" /> Tanzania</p>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="100">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.tallulah" alt="Tallulah Patricia Bär" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Tallulah Patricia B&auml;r</h3>
              <p class="speaker-role">Founder &amp; Strategic Advisor</p>
              <p class="speaker-org">Swiss Pan African</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/se.svg" alt="Sweden flag" /> Sweden</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/tallulah-patricia/" target="_blank" rel="noopener" aria-label="Tallulah Patricia Bär on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="150">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.greg" alt="Greg Young" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Greg Young</h3>
              <p class="speaker-role">Chief Executive Officer &amp; Co-Founder</p>
              <p class="speaker-org">LeaderShape Global</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/gb.svg" alt="United Kingdom flag" /> United Kingdom</p>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="200">
              <div class="speaker-tag">Panelist</div>
              <div class="speaker-avatar">
                <img :src="photos.paul" alt="Paul Rugambwa" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Paul Rugambwa</h3>
              <p class="speaker-role">President</p>
              <p class="speaker-org">Human Resource Managers&rsquo; Association of Uganda</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/ug.svg" alt="Uganda flag" /> Uganda</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/paul-rumanda-rugambwa-grp-mba-90837837/" target="_blank" rel="noopener" aria-label="Paul Rugambwa on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
          </div>
        </div>

        <!-- Facilitators -->
        <div class="category-block" data-aos="fade-up">
          <div class="category-header">
            <div class="category-icon"><i class="fas fa-chalkboard-teacher"></i></div>
            <h2 class="category-title">Facilitators</h2>
          </div>
          <div class="speakers-grid">
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="100">
              <div class="speaker-tag">Facilitator</div>
              <div class="speaker-avatar">
                <img :src="photos.zara" alt="Zara Marfo" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Zara Marfo</h3>
              <p class="speaker-role">Director (DEIS&amp;SR)</p>
              <p class="speaker-org">Adecco Group</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/gb.svg" alt="United Kingdom flag" /> United Kingdom</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/zara-m-585197144/" target="_blank" rel="noopener" aria-label="Zara Marfo on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="150">
              <div class="speaker-tag">Facilitator</div>
              <div class="speaker-avatar">
                <img :src="photos.malepo" alt="Prof. John Malepo" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Prof. John Malepo</h3>
              <p class="speaker-role">Executive Director</p>
              <p class="speaker-org">South African Association of Public Administration &amp; Management</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/za.svg" alt="South Africa flag" /> South Africa</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/john-molepo-2b06171aa/" target="_blank" rel="noopener" aria-label="Prof. John Malepo on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
            <div class="speaker-card" data-aos="fade-up" data-aos-delay="200">
              <div class="speaker-tag">Facilitator</div>
              <div class="speaker-avatar">
                <img :src="photos.olusegun" alt="Olusegun Mojeed" class="avatar-img" />
                <div class="avatar-ring"></div>
              </div>
              <h3 class="speaker-name">Olusegun Mojeed</h3>
              <p class="speaker-role">Vice President</p>
              <p class="speaker-org">African Human Resource Confederation</p>
              <p class="speaker-country"><img class="flag-icon" src="https://flagcdn.com/ng.svg" alt="Nigeria flag" /> Nigeria</p>
              <a class="speaker-linkedin" href="https://www.linkedin.com/in/olusegun-mojeed-95aa6629/" target="_blank" rel="noopener" aria-label="Olusegun Mojeed on LinkedIn"><span class="li-icon" aria-hidden="true"></span></a>
            </div>
          </div>
        </div>

        <!-- CTA -->
        <div class="speakers-cta" data-aos="zoom-in">
          <div class="cta-glow"></div>
          <h2 class="cta-title">Ready to learn from the best?</h2>
          <p class="cta-subtitle">Secure your place at AHRS 2026 and gain insights that will transform your HR practice.</p>
          <router-link to="/registration" class="cta-btn">
            <i class="fas fa-ticket-alt"></i> Register Now
          </router-link>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SpeakersView",
  data() {
    return {
      photos: {
        haroun: require("@/assets/speakers/Dr._Haroun_Ali_Suleiman.png"),
        deus: require("@/assets/speakers/Hon. Deus Clement Sangu.jpeg"),
        bettina: require("@/assets/speakers/Bettina Schaller.png"),
        quresha: require("@/assets/speakers/Quresha Addullah.jpeg"),
        ahmed: require("@/assets/speakers/Ahmed Ladan Gobir.png"),
        kgothatso: require("@/assets/speakers/Prof. Kgothatso Shai .png"),
        sharon: require("@/assets/speakers/Sharon IPME.png"),
        suzan: require("@/assets/speakers/Suzan Ndomba-Doran.jpeg"),
        francis: require("@/assets/speakers/Dr. Francis Eduku.jpg"),
        malepo: require("@/assets/speakers/PROF. JOHN MOLEPO.jpeg"),
        olusegun: require("@/assets/speakers/OLUSEGUN OLAWALE MOJEED.jpeg"),
        greg: require("@/assets/speakers/Greg Young.jpeg"),
        tarek: require("@/assets/speakers/Dr. Tarek Dessouki.jpeg"),
        emmanuel: require("@/assets/speakers/Emmanuel Akonaay.jpeg"),
        tallulah: require("@/assets/speakers/Tallulah Patricia Bar.jpeg"),
        aida: require("@/assets/speakers/Aida J Troncoso.jpeg"),
        ibrahim: require("@/assets/speakers/Ibrahim Mbaye.png"),
        kelvin: require("@/assets/speakers/Kelvin-Shemizhinga.jpg"),
        zara: require("@/assets/speakers/Zara-Marfo.jpeg"),
        paul: require("@/assets/speakers/Paul Rugambwa.jpeg"),
        murtaza: require("@/assets/speakers/Murtaza Versi.jpeg"),
      },
    };
  },
  mounted() {
    this.initParticles();
  },
  beforeUnmount() {
    if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
    if (this._resizeHandler) window.removeEventListener("resize", this._resizeHandler);
  },
  methods: {
    onHeroMouseMove(e) {
      const glow = this.$refs.cursorGlow;
      if (!glow) return;
      const rect = this.$refs.heroSection.getBoundingClientRect();
      glow.style.left = e.clientX - rect.left + "px";
      glow.style.top = e.clientY - rect.top + "px";
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");

      const resize = () => {
        const page = document.querySelector(".speakers-page");
        canvas.width = window.innerWidth;
        canvas.height = page ? page.offsetHeight : window.innerHeight;
      };
      resize();
      this._resizeHandler = resize;
      window.addEventListener("resize", resize);

      const colors = ["#4ade80", "#22c55e", "#f59e0b", "#10b981", "#86efac"];
      const particles = Array.from({ length: 60 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 2.5 + 0.5,
        color: colors[Math.floor(Math.random() * colors.length)],
        vx: (Math.random() - 0.5) * 0.4,
        vy: (Math.random() - 0.5) * 0.4,
        alpha: Math.random() * 0.6 + 0.2,
      }));

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach((p) => {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle =
            p.color +
            Math.floor(p.alpha * 255)
              .toString(16)
              .padStart(2, "0");
          ctx.fill();
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
          if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
        });
        this.animationFrame = requestAnimationFrame(draw);
      };
      draw();
    },
  },
};
</script>

<style scoped>
/* ── Page Shell ─────────────────────────────────────── */
.speakers-page {
  min-height: 100vh;
  background: #f8faf9;
  position: relative;
  overflow: hidden;
}

/* Editorial hero backdrop photo */
.hero-photo-speakers {
  --hero-photo: url("~@/assets/images/past Ahrs/guest with microphone.jpg");
}

/* ── Animated Background ────────────────────────────── */
.animated-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.particle-canvas {
  position: absolute;
  inset: 0;
  opacity: 0.7;
}

.bg-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(74, 222, 128, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(74, 222, 128, 0.1) 1px, transparent 1px);
  background-size: 60px 60px;
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.3;
}
.orb-1 {
  width: 600px; height: 600px;
  background: radial-gradient(circle, #1a472a, transparent);
  top: -150px; left: -150px;
  animation: orbFloat 12s ease-in-out infinite;
}
.orb-2 {
  width: 500px; height: 500px;
  background: radial-gradient(circle, #4ade80, transparent);
  bottom: 20%; right: -100px;
  animation: orbFloat 15s ease-in-out infinite reverse;
}
.orb-3 {
  width: 400px; height: 400px;
  background: radial-gradient(circle, #bbf7d0, transparent);
  top: 40%; left: 40%;
  animation: orbFloat 18s ease-in-out infinite;
}

.light-stream {
  position: absolute;
  width: 1px;
  background: linear-gradient(to bottom, transparent, rgba(26, 71, 42, 0.12), transparent);
  animation: streamFlow 6s ease-in-out infinite;
}
.stream-1 { height: 40%; top: 5%; left: 20%; animation-delay: 0s; }
.stream-2 { height: 30%; top: 30%; left: 75%; animation-delay: 3s; }

.geo-shape {
  position: absolute;
  opacity: 0.22;
  animation: geoSpin 20s linear infinite;
}
.hex {
  width: 300px; height: 300px;
  border: 2px solid #4ade80;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  top: 10%; right: 5%;
}
.triangle {
  width: 200px; height: 200px;
  border: 2px solid #f59e0b;
  clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
  bottom: 15%; left: 5%;
  animation-direction: reverse;
}
.circle-ring {
  width: 250px; height: 250px;
  border: 2px solid #86efac;
  border-radius: 50%;
  top: 55%; right: 15%;
  animation-duration: 30s;
}

@keyframes orbFloat {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(30px, 20px); }
}
@keyframes streamFlow {
  0%, 100% { opacity: 0; transform: scaleY(0.5); }
  50% { opacity: 1; transform: scaleY(1); }
}
@keyframes geoSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ── Container ──────────────────────────────────────── */
.container-wide {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

/* ── Hero ───────────────────────────────────────────── */
.speakers-hero {
  position: relative;
  padding: 140px 0 110px;
  text-align: center;
  z-index: 2;
  background: linear-gradient(135deg, #0f2419 0%, #1a472a 60%, #2d5f3f 100%);
  overflow: hidden;
}

/* Mouse-follow glow */
.hero-cursor-glow {
  position: absolute;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(74, 222, 128, 0.15), transparent 70%);
  transform: translate(-50%, -50%);
  pointer-events: none;
  transition: left 0.08s ease, top 0.08s ease;
  z-index: 0;
}

/* Floating pills */
.hero-pill {
  position: absolute;
  background: rgba(74, 222, 128, 0.1);
  border: 1px solid rgba(74, 222, 128, 0.25);
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 6px;
  backdrop-filter: blur(6px);
  pointer-events: none;
  z-index: 1;
}
.hero-pill i { color: #4ade80; }
.pill-1 { top: 22%; left: 7%; animation: pillFloat 6s ease-in-out infinite; }
.pill-2 { top: 35%; right: 8%; animation: pillFloat 8s ease-in-out infinite reverse; }
.pill-3 { bottom: 28%; left: 5%; animation: pillFloat 7s ease-in-out infinite 1s; }
@keyframes pillFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

/* Stats bar */
.hero-stats {
  display: inline-flex;
  align-items: center;
  gap: 0;
  margin-top: 40px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(74, 222, 128, 0.2);
  border-radius: 60px;
  padding: 16px 36px;
  backdrop-filter: blur(12px);
  flex-wrap: wrap;
  justify-content: center;
}
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px;
}
.stat-num {
  font-size: 1.8rem;
  font-weight: 800;
  color: #4ade80;
  line-height: 1;
}
.stat-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 4px;
}
.stat-divider {
  width: 1px;
  height: 36px;
  background: rgba(74, 222, 128, 0.2);
  flex-shrink: 0;
}

/* Wave */
.hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  line-height: 0;
}
.hero-wave svg {
  display: block;
  width: 100%;
  height: 90px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(74, 222, 128, 0.12);
  border: 1px solid rgba(74, 222, 128, 0.35);
  color: #4ade80;
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 24px;
  backdrop-filter: blur(8px);
}
.badge-icon { font-size: 1rem; }

.hero-title {
  font-size: clamp(2.4rem, 5vw, 4rem);
  font-weight: 800;
  color: #ffffff;
  line-height: 1.1;
  margin-bottom: 20px;
}
.title-highlight {
  background: linear-gradient(90deg, #4ade80, #f59e0b, #4ade80);
  background-size: 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 4s linear infinite;
}
@keyframes shimmer {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

.hero-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.65);
  max-width: 600px;
  margin: 0 auto 28px;
  line-height: 1.7;
}

.hero-meta {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.meta-item {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 6px;
}
.meta-item i { color: #4ade80; }
.meta-divider { color: rgba(255, 255, 255, 0.2); }

/* ── Content Area ───────────────────────────────────── */
.speakers-content {
  position: relative;
  z-index: 2;
  padding: 80px 0 100px;
}

/* ── Category Block ─────────────────────────────────── */
.category-block {
  margin-bottom: 80px;
}

.category-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 40px;
  text-align: center;
}

.category-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #1a472a, #2d5f3f);
  border: 1px solid rgba(74, 222, 128, 0.3);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4ade80;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.category-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f2419;
  position: relative;
}
.category-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #4ade80, transparent);
  border-radius: 2px;
}

/* ── Speakers Grid ──────────────────────────────────── */
.speakers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  justify-content: center;
  gap: 24px;
}

.featured-grid {
  grid-template-columns: minmax(280px, 460px);
}

/* ── Speaker Card ───────────────────────────────────── */
.speaker-card {
  background: #ffffff;
  border: 1px solid rgba(26, 71, 42, 0.14);
  border-radius: 20px;
  padding: 32px 28px;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.09), 0 1px 4px rgba(0, 0, 0, 0.05);
}
.speaker-card:hover {
  transform: translateY(-8px);
  border-color: rgba(74, 222, 128, 0.55);
  box-shadow: 0 20px 50px rgba(26, 71, 42, 0.15), 0 0 0 2px rgba(74, 222, 128, 0.2);
}

.featured-card {
  border-color: rgba(26, 71, 42, 0.22);
  background: #f0fdf4;
  box-shadow: 0 6px 30px rgba(26, 71, 42, 0.1), 0 1px 4px rgba(0, 0, 0, 0.05);
}

.card-glow {
  position: absolute;
  top: -50%;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(74, 222, 128, 0.12), transparent 70%);
  pointer-events: none;
}

/* ── Special Guests — majestic emerald glow ─────────── */
.special-guests-grid .speaker-card {
  border-color: rgba(4, 120, 87, 0.45);
  background: linear-gradient(160deg, #f4fcf8 0%, #e3f6ec 100%);
  box-shadow: 0 6px 30px rgba(4, 120, 87, 0.2), 0 1px 4px rgba(0, 0, 0, 0.05);
}
.special-guests-grid .speaker-card::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  box-shadow: inset 0 0 0 1px rgba(6, 95, 70, 0.3);
  opacity: 0.8;
  transition: opacity 0.3s ease;
}
.special-guests-grid .speaker-card:hover {
  border-color: rgba(4, 120, 87, 0.85);
  box-shadow: 0 22px 55px rgba(4, 120, 87, 0.34), 0 0 0 2px rgba(16, 185, 129, 0.4);
  transform: translateY(-8px);
}
.special-guests-grid .speaker-card:hover::after {
  opacity: 1;
}
.special-guests-grid .card-glow {
  width: 260px;
  height: 260px;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.34), transparent 68%);
  animation: emeraldGlowPulse 4.5s ease-in-out infinite;
}
@keyframes emeraldGlowPulse {
  0%, 100% { opacity: 0.55; transform: translateX(-50%) scale(1); }
  50% { opacity: 1; transform: translateX(-50%) scale(1.18); }
}

.speaker-tag {
  display: inline-block;
  background: linear-gradient(135deg, #1a472a, #4ade80);
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding: 4px 14px;
  border-radius: 50px;
  margin-bottom: 20px;
}

/* Avatar */
.speaker-avatar {
  position: relative;
  width: 90px;
  height: 90px;
  margin: 0 auto 20px;
}
.avatar-initials {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a472a 0%, #4ade80 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
}
.avatar-img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center top;
  display: block;
  position: relative;
  z-index: 1;
  background: #f0fdf4;
}
.avatar-initials.avatar-tba {
  background: linear-gradient(135deg, #94a3b8, #cbd5e1);
  font-size: 2rem;
  color: #f8fafc;
}
.avatar-ring {
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 2px solid transparent;
  background: linear-gradient(135deg, #4ade80, #f59e0b) border-box;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: destination-out;
  mask-composite: exclude;
  animation: ringPulse 2.5s ease-in-out infinite;
}
@keyframes ringPulse {
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.05); }
}

.speaker-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f2419;
  margin-bottom: 6px;
}
.speaker-role {
  font-size: 0.9rem;
  color: #1a472a;
  font-weight: 600;
  margin-bottom: 4px;
}
.speaker-org {
  font-size: 0.88rem;
  color: #6b7280;
  margin-bottom: 6px;
}
.speaker-country {
  font-size: 0.82rem;
  color: #9ca3af;
  font-style: italic;
  margin-bottom: 14px;
}
.speaker-country i { color: #f59e0b; margin-right: 4px; }
.speaker-country .flag-icon {
  width: 22px;
  height: 15px;
  object-fit: cover;
  border-radius: 2px;
  margin-right: 6px;
  vertical-align: -2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.18);
}

.speaker-linkedin {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  color: #119548;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(17, 149, 73, 0.18);
  box-shadow: 0 4px 14px rgba(26, 71, 42, 0.08);
  opacity: 0.85;
  transform: translateY(0) scale(0.94);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
    opacity 0.3s ease, color 0.3s ease, box-shadow 0.3s ease,
    border-color 0.3s ease, background 0.3s ease;
}
/* gradient fill that wipes in on hover */
.speaker-linkedin::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(135deg, #1a472a, #119548 55%, #4ade80);
  opacity: 0;
  transform: scale(0.6);
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: -1;
}
.speaker-card:hover .speaker-linkedin {
  opacity: 1;
  transform: translateY(0) scale(1);
}
.speaker-linkedin:hover {
  color: #fff;
  border-color: transparent;
  transform: translateY(-3px) scale(1.06);
  box-shadow: 0 10px 22px rgba(17, 149, 73, 0.4);
}
.speaker-linkedin:hover::before {
  opacity: 1;
  transform: scale(1);
}
.speaker-linkedin .li-icon {
  width: 22px;
  height: 22px;
  background-color: currentColor;
  transition: transform 0.3s ease;
  -webkit-mask: url("~@/assets/icons/linkedin-svgrepo-com.svg") center / contain no-repeat;
  mask: url("~@/assets/icons/linkedin-svgrepo-com.svg") center / contain no-repeat;
}
.speaker-linkedin:hover .li-icon {
  transform: scale(1.08);
}

.speaker-bio {
  font-size: 0.88rem;
  color: #374151;
  line-height: 1.6;
  margin-bottom: 14px;
  background: #f9fafb;
  border-radius: 10px;
  padding: 12px;
  border-left: 2px solid rgba(26, 71, 42, 0.3);
  text-align: left;
}

.speaker-topic {
  font-size: 0.85rem;
  color: #1a472a;
  background: rgba(26, 71, 42, 0.06);
  border: 1px solid rgba(26, 71, 42, 0.15);
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 500;
  text-align: left;
}
.speaker-topic i { margin-right: 6px; color: #4ade80; }

/* ── Guest of Honor (special) ───────────────────────── */
.honor-block {
  margin-bottom: 80px;
  display: flex;
  justify-content: center;
}
.honor-card {
  position: relative;
  width: 100%;
  max-width: 740px;
  text-align: center;
  padding: 56px 48px;
  border-radius: 28px;
  background:
    radial-gradient(ellipse at top, rgba(245, 197, 24, 0.2), transparent 60%),
    linear-gradient(135deg, #0b2c1a 0%, #14401f 55%, #1a472a 100%);
  border: 1px solid rgba(245, 197, 24, 0.45);
  box-shadow:
    0 30px 80px rgba(11, 44, 26, 0.45),
    inset 0 0 0 1px rgba(245, 197, 24, 0.12);
  overflow: hidden;
}
.honor-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: url("https://flagcdn.com/tz.svg") center / cover no-repeat;
  opacity: 0.22;
  pointer-events: none;
  z-index: 0;
}
.honor-card > * {
  position: relative;
  z-index: 1;
}
.honor-shine {
  position: absolute;
  top: -60%;
  left: -20%;
  width: 140%;
  height: 120%;
  background: radial-gradient(circle, rgba(245, 197, 24, 0.16), transparent 60%);
  pointer-events: none;
  animation: honorGlow 6s ease-in-out infinite;
}
@keyframes honorGlow {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}
.honor-corner {
  position: absolute;
  width: 56px;
  height: 56px;
  border: 2px solid rgba(245, 197, 24, 0.55);
  pointer-events: none;
}
.honor-corner-tl {
  top: 18px;
  left: 18px;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 12px;
}
.honor-corner-br {
  bottom: 18px;
  right: 18px;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 12px;
}
.honor-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #f5c518, #e0a800);
  color: #0b2c1a;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 7px 22px;
  border-radius: 50px;
  margin-bottom: 28px;
  box-shadow: 0 8px 24px rgba(245, 197, 24, 0.35);
}
.honor-avatar {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto 24px;
  border-radius: 50%;
  padding: 4px;
  background: linear-gradient(135deg, #f5c518, #e0a800, #f5c518);
  box-shadow: 0 0 0 6px rgba(245, 197, 24, 0.12);
}
.honor-avatar-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg, #14401f, #2d5f3f);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: rgba(245, 197, 24, 0.85);
}
.honor-avatar .avatar-img {
  width: 100%;
  height: 100%;
  background: #14401f;
}
.honor-name {
  position: relative;
  font-size: clamp(1.6rem, 3vw, 2.3rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 8px;
}
.honor-role {
  position: relative;
  font-size: 0.95rem;
  color: #f5c518;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 22px;
}
.honor-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin: 0 auto 20px;
  max-width: 280px;
  color: rgba(245, 197, 24, 0.75);
}
.honor-divider span {
  height: 1px;
  flex: 1;
  background: linear-gradient(90deg, transparent, rgba(245, 197, 24, 0.5));
}
.honor-divider span:last-child {
  background: linear-gradient(90deg, rgba(245, 197, 24, 0.5), transparent);
}
.honor-note {
  position: relative;
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.72);
  max-width: 440px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ── CTA ────────────────────────────────────────────── */
.speakers-cta {
  text-align: center;
  margin-top: 60px;
  padding: 60px 40px;
  background: linear-gradient(135deg, #0f2419 0%, #1a472a 60%, #2d5f3f 100%);
  border: 1px solid rgba(74, 222, 128, 0.25);
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(15, 36, 25, 0.35);
}
.cta-glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at center, rgba(74, 222, 128, 0.14), transparent 70%);
  pointer-events: none;
}
.cta-title {
  font-size: 2rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
}
.cta-subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.82);
  max-width: 500px;
  margin: 0 auto 30px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #1a472a, #4ade80);
  color: #ffffff;
  font-weight: 700;
  font-size: 1rem;
  padding: 14px 36px;
  border-radius: 50px;
  text-decoration: none;
  letter-spacing: 0.5px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 8px 30px rgba(74, 222, 128, 0.3);
}
.cta-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 40px rgba(74, 222, 128, 0.5);
  color: #ffffff;
}

/* ── Responsive ─────────────────────────────────────── */
@media (max-width: 768px) {
  .speakers-hero { padding: 120px 0 100px; }
  .hero-title { font-size: 2.2rem; }
  .hero-pill { display: none; }
  .hero-stats { padding: 12px 20px; gap: 0; }
  .stat-item { padding: 0 14px; }
  .stat-num { font-size: 1.4rem; }
  .speakers-grid { grid-template-columns: 1fr; }
  .featured-grid { grid-template-columns: 1fr; }
  .category-header { flex-direction: column; align-items: center; gap: 10px; }
  .speakers-cta { padding: 40px 24px; }
  .cta-title { font-size: 1.5rem; }
  .speakers-content { padding: 60px 0 80px; }
  .honor-card { padding: 40px 22px; }
  .honor-avatar { width: 110px; height: 110px; }
  .honor-avatar-inner { font-size: 2.4rem; }
  .honor-corner { width: 40px; height: 40px; }
}
</style>
